import axios from 'axios';
import Vue from 'vue'

export default {

    findItems (page, pageSize,selectedBrandsList,reference, selectedGroup, selectedSubGroup, filterItemAvailable, filterItemHasImage,
         filterItemHasDescription, filterDescription, filterPriceMin, filterPriceMax,
         itemForm,  dci, searchInNewItemsOnly, searchInNewItemsLast24Only, searchInNewCreationsOnly,
         searchInItemsWithGratuitiesOnly,  searchInItemsWithControlledSalesOnly, searchParaOnly,
          searchPharmaOnly , requestTimestamp, searchInItemsWithRepartitionSalesOnly,searchInWebNouvLancementPara, searchInWebNouvEntrePara, dbAgencyId) {

        return axios.get('/api/items/list', { params: {page: page, pageSize: pageSize, selectedBrandsList:selectedBrandsList.join(','),
        reference:reference, selectedGroup:selectedGroup, 
        selectedSubGroup:selectedSubGroup,  filterItemAvailable:filterItemAvailable, filterItemHasImage:filterItemHasImage, 
        filterItemHasDescription: filterItemHasDescription, filterDescription:filterDescription,
        filterPriceMin:filterPriceMin, filterPriceMax:filterPriceMax, itemForm: itemForm, dci:dci, 
        
        searchInNewItemsOnly:searchInNewItemsOnly, 
        searchInNewItemsLast24Only:searchInNewItemsLast24Only, 
        searchInNewCreationsOnly:searchInNewCreationsOnly,
        searchInItemsWithGratuitiesOnly: searchInItemsWithGratuitiesOnly,
        searchInItemsWithControlledSalesOnly: searchInItemsWithControlledSalesOnly,
        searchInItemsWithRepartitionSalesOnly:searchInItemsWithRepartitionSalesOnly,

        searchParaOnly: searchParaOnly,
        searchPharmaOnly: searchPharmaOnly, dbAgencyId: dbAgencyId,
        searchInWebNouvLancementPara: searchInWebNouvLancementPara,
        searchInWebNouvEntrePara: searchInWebNouvEntrePara,
                
        requestTimestamp: requestTimestamp} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    importImages(formData){
        return axios.post('/api/image/import-images', formData, {headers: {'Content-Type': 'multipart/form-data' }})
        .then((response) => {
            Vue.prototype.$snotify.success("Import des images terminé");
            if (response && response.data) {
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getGroups () {
        return axios.get('/api/items/groups/')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSubGroups (group) {

        if (group != null) {
            return axios.get('/api/items/subgroups/', { params: {groupId:group.id} })
            .then(response => {
                if (response && response.data) return response.data
            })
            .catch(error => {Vue.prototype.$snotify.error(error);})
        }
    },

    
    getSimilairItems (page, pageSize,itemId, dbAgencyId) {
        return axios.get('/api/items/similair/', { params: {page: page, pageSize: pageSize,itemId:itemId, dbAgencyId:dbAgencyId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getRecommendedItemslist (page, pageSize,itemRef, dbAgencyId) {
        return axios.get('/api/items/recommandation/', { params: {page: page, pageSize: pageSize,itemRef:itemRef, dbAgencyId:dbAgencyId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getCategories (level, customerId, parentId, page, pageSize) {
        return axios.get('/api/items/categories', { params: { level: level, customerId: customerId, parentId: parentId, page: page, pageSize: pageSize } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getSupplierItems (supplierId) {
        return axios.get('/api/items/list',{params: {supplierId: supplierId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    }, 

    getNewItems (dbAgencyId) {
        return axios.get('/api/items/get-new-items', { params: { dbAgencyId: dbAgencyId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    }, 

    getMaxFileSize() {
        return axios.get('/api/items/size')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getAllBrands(){
        return axios.get('/api/items/brand/all')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllDci(){
        return axios.get('/api/items/dci/all')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllItemForms(){
        return axios.get('/api/items/item-form/all')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getClaimTypes() {
        return axios.get('/api/items/claim/type')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    submitClaim(claimTypeId, itemId, itemRef, details) {

        var claim = {claimTypeId: claimTypeId, itemId: itemId, itemRef: itemRef, details: details};
        return axios.post('/api/items/claim/submit', claim)
            .then(response => {
                if (response && response.data) {
                    if (response.data) {
                        Vue.prototype.$snotify.success("Réclamation n° " + response.data + " envoyée !");
                    }
                    return response.data;
                }
            })
            .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAttributes(itemId) {
        return axios.get('/api/items/attributes?itemId=' + itemId)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addNewBrand(newBrandName){
        var newBrand = {name: newBrandName};
        return axios.post('/api/items/brand/new', newBrand)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Marque ajoutée avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    addNewGroup(newGroupName){
        var newGroup = {name: newGroupName};
        return axios.post('/api/items/itemGroup/new', newGroup)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Groupe ajouté avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    addNewSubGroup(newGroupName, groupId){
        var newGroup = {name: newGroupName, groupId: groupId};
        return axios.post('/api/items/itemSubGroup/new', newGroup)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Groupe ajouté avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },


    
    deleteBrand(brand){
        return axios.post("/api/items/brand/remove/", brand)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Marque supprimée avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    changeBrandName(brand, newName){
        return axios.post('/api/items/brand/edit',{brand: brand, newName:newName})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Marque modifiée avec succès");
                return response.data
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    changeGroupName(itemGroup,newName){
        return axios.post('/api/items/group/edit',{itemGroup: itemGroup, newName:newName})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Groupe modifié avec succès");
                return response.data
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    changeSubGroupName(itemGroup,newName){
        return axios.post('/api/items/subgroup/edit',{itemGroup: itemGroup, newName:newName})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Groupe modifié avec succès");
                return response.data
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteGroup(itemGroup){
        return axios.post("/api/items/group/remove/", itemGroup)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Groupe supprimé avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteSubGroup(itemGroup){
        return axios.post("/api/items/subgroup/remove/", itemGroup)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Sous-Groupe supprimé avec succès");
                return response.data;
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    uploadCSV(formData){
        return axios.post("/api/items/file/", formData, {headers: {'Content-Type': 'multipart/form-data' } },   { timeout: 900000 })
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success('Le fichier CSV est importé avec succès');
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    syncItems() {
        return axios.get('/api/items/force-sync')
        .then(response => {
            if (response && response.data) Vue.prototype.$snotify.success("La synchronisation des articles est lancée");
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getLastItemImport(){
        return axios.get('/api/items/last-item-import-date')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getItemImportCounts(){
        return axios.get('/api/items/item-import-counts')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    resetGratuities(){
        return axios.get('/api/items/reset-gratuities')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
}

